import React, { memo, useEffect, useState } from "react";
import { SwitcherProps, SwitcherOptionsProps } from "./props";
import Collapsible from '../../private/Collapsible/Collapsible';
import collapsible from '../../private/Collapsible/props';
import style from "./style.module.scss";
import classNames from "../../../utils/classNames";
import get from 'lodash/get';

function Switcher(props: SwitcherProps) {
  const {rel, defaultIndex = 0, fullWidth = false, switcherPrimary = false, options, onSwitch} = props;
  const [currentIdx, setCurrentIdx] = useState(defaultIndex);

  useEffect(() => {
    setCurrentIdx(defaultIndex);
  }, [defaultIndex]);

  return (
    <div
      className={classNames("switcher-wrapper", style, {
        "full-width": fullWidth,
        "switcher-primary": switcherPrimary,
      })}
      role="radiogroup"
    >
      {options.map((opt, idx) => (
        <span key={opt.name} className={classNames("switcher-option", style)}>
          <span
            className={classNames("switcher-option-action", style, {
              active: currentIdx === idx,
              "active-primary": switcherPrimary,
            })}
          >
            <input
              checked={currentIdx === idx}
              className={classNames("switcher-option-input", style)}
              id={opt.name}
              onChange={(evt) => {
                setCurrentIdx(idx);
                onSwitch(evt, opt.value);
              }}
              name="switcher"
              type="radio"
              value={opt.value}
            />
            {opt.type === 'dropdown' && (
              <div id={`dropdown-${opt.name}`}>
                <Collapsible
                  {...dropdownProps(opt)}
                  onChange={(e, value) => {
                    setCurrentIdx(idx);
                    onSwitch(null, opt.value);
                    opt.onDropdownChange && opt.onDropdownChange(e, value);
                  }}
                  onClick={() => {opt.onDropdownClick && opt.onDropdownClick(); }}
                />
              </div>
            ) }
          </span>
          {opt.href ? (
            <a
              className={classNames("switcher-option-label", style)}
              rel={opt.rel || rel}
              href={opt.href}
              onClick={(e) => e.preventDefault()}
            >
              {opt.label}
            </a>
          ) : (
            <label
            className={classNames("switcher-option-label", style, { "dropdownOption": opt.type === 'dropdown' })}
            htmlFor={opt.name}
            >
              {opt.label}
            </label>
          )}
        </span>
      ))}
    </div>
  );
}

const dropdownProps = (optProps: SwitcherOptionsProps) : collapsible => {
  const dropdownOptions = get(optProps,'dropdownOptions',[]) as [{label: string}] ;
  const ListProps = dropdownOptions.map((dropdownOption) => {
    return {Label: {text: dropdownOption.label}}
  });
  const collapsibleProps = {
    classNames: {
      dropdown: false,
      grey: false,
      overlap: false,
      activeTick: false
    },
    header: optProps.label,
    InputGroup: undefined,
    List: {
      items: [...ListProps]
    }
  };
  return collapsibleProps;
};

export default memo(Switcher);
